import { Badge } from 'antd';
import styled from 'styled-components';

export const Board = styled.div`
  width: 100%;
  overflow-x: visible;
  height: calc(100vh - 250px);
`;

export const Container = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  height: 100%;
`;

export const Column = styled.div`
  flex: 1 1 0;
  min-width: 0;
  height: calc(100vh - 250px);
  display: flex;
  flex-direction: column;

  /* Ensure Ant Design Card takes full height */
  .ant-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
  }

  .ant-card-body {
    flex: 1;
    padding: 0 !important;
    display: flex;
    flex-direction: column;
  }

  .ant-card-head {
    flex-shrink: 0;
  }
`;

export const ConvitesColumn = styled.div`
  flex: 1 1 0;
  min-width: 0;
  height: calc(100vh - 250px);
  display: flex;
  flex-direction: column;

  .ant-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
  }

  .ant-card-body {
    flex: 1;
    padding: 0 !important;
    display: flex;
    flex-direction: column;
  }

  .ant-card-head {
    flex-shrink: 0;
  }
`;

export const ExtraContainer = styled.div``;

export const ExtraTotalBadge = styled(Badge).attrs({
  style: {
    backgroundColor: '#fff',
    color: '#999',
    boxShadow: '0 0 0 1px #d9d9d9 inset',
  },
})``;

export const ColumnContent = styled.div`
  padding: 8px;
  width: 100%;
  background-color: #f5f5f5;
  flex: 1;
  overflow-y: auto;
  
  /* Custom scrollbar styling */
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const LoadingSkeletonContainer = styled.div`
  margin: 0 0 8px 0;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  height: 80px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const SkeletonLine = styled.div`
  height: ${props => props.height || '12px'};
  width: ${props => props.width || '100%'};
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.5s infinite;
  
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;